import { render, staticRenderFns } from "./LOSPreviewSvg.vue?vue&type=template&id=164dd7fe&scoped=true&"
import script from "./LOSPreviewSvg.vue?vue&type=script&lang=js&"
export * from "./LOSPreviewSvg.vue?vue&type=script&lang=js&"
import style0 from "./LOSPreviewSvg.vue?vue&type=style&index=0&id=164dd7fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164dd7fe",
  null
  
)

export default component.exports